import React from "react";
import "./index.scss";

const statusConfig = {
  pending: {
    label: "Pending",
    color: "#ffc107",
    bgColor: "#fff3cd",
  },
  accepted: {
    label: "Accepted",
    color: "#28a745",
    bgColor: "#d4edda",
  },
  declined: {
    label: "Declined",
    color: "#dc3545",
    bgColor: "#f8d7da",
  },
};

export const InviteeList = ({ invitees }) => {
  if (!invitees || invitees.length === 0) {
    return <p className="text-muted">No invitees</p>;
  }

  const counts = {
    accepted: invitees.filter((i) => i.status === "accepted").length,
    pending: invitees.filter((i) => i.status === "pending").length,
    declined: invitees.filter((i) => i.status === "declined").length,
  };

  return (
    <div className="invitee-list">
      <div className="invitee-header">
        <h6>Invitees ({invitees.length})</h6>
      </div>

      {/* Summary badges */}
      <div className="invitee-summary">
        {counts.accepted > 0 && (
          <span className="summary-badge accepted">
            {counts.accepted} Accepted
          </span>
        )}
        {counts.pending > 0 && (
          <span className="summary-badge pending">
            {counts.pending} Pending
          </span>
        )}
        {counts.declined > 0 && (
          <span className="summary-badge declined">
            {counts.declined} Declined
          </span>
        )}
      </div>

      {/* Invitee list - only show individual items if 15 or fewer */}
      {invitees.length <= 15 ? (
        <ul className="invitee-items">
          {invitees.map((invitee, index) => {
            const status = statusConfig[invitee.status] || statusConfig.pending;
            return (
              <li key={invitee.responseToken || index} className="invitee-item">
                <div className="invitee-info">
                  <span className="invitee-name">
                    {invitee.firstName} {invitee.lastName}
                  </span>
                  <span className="invitee-email">{invitee.clientEmail}</span>
                </div>
                <span
                  className="invitee-status"
                  style={{
                    backgroundColor: status.bgColor,
                    color: status.color,
                  }}
                >
                  {status.label}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="invitee-count-message">
          <p>This appointment has {invitees.length} invitees. View summary above.</p>
        </div>
      )}
    </div>
  );
};

export default InviteeList;
